export const DISCOVERY_CARD_DATE_TIME_OPTS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
};

export const DISCOVERY_CARD_DATE_ONLY_OPTS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

/**
 * Single date/time line for search cards (Sharetribe + primary), when a value exists.
 * Uses `intl.formatDate` when the value parses as a date; otherwise returns trimmed string.
 */
export const formatDiscoveryCardDateLine = (intl, raw) => {
  if (raw == null) {
    return null;
  }
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
    return intl.formatDate(raw, DISCOVERY_CARD_DATE_TIME_OPTS);
  }
  const s = String(raw).trim();
  if (!s) {
    return null;
  }
  const parsed = Date.parse(s);
  if (Number.isFinite(parsed)) {
    return intl.formatDate(new Date(parsed), DISCOVERY_CARD_DATE_TIME_OPTS);
  }
  return s;
};
